"use client";

import { useLinkStatus } from "next/link";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isSettingsHubPath, pathWithoutLocale } from "@/lib/localePath";
import { useNavigationPending } from "./NavigationPendingContext";

/**
 * Must render as a direct or nested child of `<Link>`.
 * Syncs Next.js link pending state to the main-content overlay skeleton.
 */
export default function LinkPendingNotifier({
  pathAfterLocale,
}: {
  /** Path without locale prefix, e.g. `/following`, `/schedules` */
  pathAfterLocale: string;
}) {
  const { pending } = useLinkStatus();
  const { setPendingFromLink } = useNavigationPending();
  const location = useLocation();
  const currentPath = pathWithoutLocale(location.pathname);

  useEffect(() => {
    if (
      pending &&
      isSettingsHubPath(pathAfterLocale) &&
      isSettingsHubPath(currentPath)
    ) {
      return;
    }
    setPendingFromLink(pathAfterLocale, pending);
  }, [pending, pathAfterLocale, currentPath, setPendingFromLink]);

  return null;
}
